import type { Stop } from "../types";

const ONLY_25XX_RE = /^25\d{2}$/;

/**
 * True if a single line id is a 25xx line.
 */
export function is25xx(id: string | number): boolean {
  return ONLY_25XX_RE.test(String(id));
}

/**
 * True if the stop only has 25xx lines.
 * Used for deciding if we show "n"-icon.
 */
export function isPureNartrafikFromStop(stop: Stop): boolean {
  const ids = (stop.servedLineIds ?? []).map(String);
  return ids.length > 0 && ids.every(is25xx);
}
